import { atlas } from '~/services/serviceInstances';

import { DeletePlaybookApiArg } from '../../types/playbooks/playbooks';

export const deletePlaybook = async ({
  playbookId,
}: DeletePlaybookApiArg): Promise<void> => {
  return atlas.remove(`playbooks/${playbookId}`);
};
